uniform sampler2D uNoise;

varying vec3 vNormal;
varying float vElevation;

void main() {
  vec4 modelPosition = modelMatrix * vec4(position, 1.0);
  vec4 elevation = texture2D(uNoise, uv);
  modelPosition.y += elevation.r * 10.0 ;
  // float noiseVal = elevation.r;
  // float steppedVal;
  // if(noiseVal < 0.25) {
  //   steppedVal = -1.0;
  // } else if(noiseVal < 0.5) {
  //   steppedVal = 0.0;
  // } else if(noiseVal < 0.75) {
  //   steppedVal = 1.0;
  // } else {
  //   steppedVal = 2.0;
  // }

  // modelPosition.y = steppedVal;

  vec4 viewPosition = viewMatrix * modelPosition;
  vec4 projectionPosition = projectionMatrix * viewPosition;
  gl_Position = projectionPosition;

  // Varyings
  vec4 modelNormal = modelMatrix *  vec4(normal, 0.0);
  vNormal = modelNormal.xyz;
  vElevation = elevation.r;
}